import { Component } from 'react';
import Avatar from './avatar';

class UsersAndGroupsListEntry extends Component {
  render() {
    const { entry } = this.props;
    return entry.isGroup ? this.renderGroup(entry) : this.renderUser(entry);
  }

  renderUser = (user) => {
    const avatar = (
      <div className="users-and-groups-list-entry--gravatar">
        <Avatar size={30} name={this.props.entry.name} avatarSrc={this.props.entry.avatar} />
      </div>
    );
    return this.renderItem(user.name, user.label, avatar);
  };

  renderGroup = (group) => {
    const avatar = (
      <div className="users-and-groups-list-entry--gravatar">
        <img className="avatar" src="/images/group.svg" />
      </div>
    );
    return this.renderItem(group.name, 'Group', avatar);
  };

  renderItem = (name, subtext, avatar) => {
    const whiteBackgroundCls = this.props.whiteBackground ? 'users-and-groups-white-background' : '';
    const activeClass = this.props.isActive ? 'users-and-groups-list-entry--active' : '';
    return (
      <li className={`users-and-groups-list-entry ${activeClass} ${whiteBackgroundCls}`} onClick={this.handleClick}>
        {avatar}
        <div className="users-and-groups-list-entry--text-wrapper">
          <div className="users-and-groups-list-entry--text">{name}</div>
          <div className={`users-and-groups-list-entry--text ${whiteBackgroundCls}`}>{subtext}</div>
        </div>
      </li>
    );
  };

  handleClick = (e) => {
    e.preventDefault();
    this.props.onEntryClick(this.props.entry);
  };
}

export default UsersAndGroupsListEntry;
